
import { Container } from "react-bootstrap";
import Footer from "./Footer";

function Privacy() {
  return (
    <>
    <div className="container sub-page">
      <Container style={{ padding: "60px 0 0" }}>
        <h1 className="fw-bold">Privacy Policy</h1>

        <p className="mt-2">
          At <strong>bankstatements</strong>, we are committed to protecting
          your privacy. This Privacy Policy outlines how we collect, use, and
          safeguard your personal information when you use our website.
        </p>

        <h5 className="fw-bold mt-5">1. Information We Collect</h5>
        <p>
          We may collect information that you provide directly to us, such as:
        </p>
        <ul className="pl-1" style={{ color: "gray", fontSize: "16px" }}>
          <li>Name and email address via contact forms or subscriptions</li>
          <li>Feedback and inquiries submitted through the website</li>
          <li>Usage data (e.g., pages visited, links clicked, time spent)</li>
        </ul>

        <h5 className="fw-bold mt-5">2. How We Use Your Information</h5>
        <p>We use the collected data to:</p>
        <ul className="pl-1" style={{ color: "gray", fontSize: "16px" }}>
          <li>Improve our website content and functionality</li>
          <li>Respond to user inquiries and support requests</li>
          <li>Send newsletters or updates (if opted in)</li>
          <li>
            Analyze trends and user behavior (using Google Analytics or similar
            tools)
          </li>
        </ul>

        <h5 className="fw-bold mt-5">3. Cookies and Tracking</h5>
        <p>
          We use cookies to enhance your experience. You can control cookie
          settings through your browser. Cookies help us understand user
          preferences and deliver relevant content.
        </p>

        <h5 className="fw-bold mt-5">4. Third Party Services</h5>
        <p>
          We may use third party tools (e.g., analytics or social media plugins)
          that collect information in accordance with their own privacy
          policies. We do not share your personal data with advertisers or
          marketers.
        </p>

        <h5 className="fw-bold mt-5">5. Data Security</h5>
        <p>
          We implement industry standard measures to protect your information
          from unauthorized access. However, no system can guarantee absolute
          security.
        </p>

        <h5 className="fw-bold mt-5">6. Your Rights</h5>
        <p>
          You may contact us at any time to access, update, or delete your
          personal information stored with us.
        </p>

        <h5 className="fw-bold mt-5">7. Changes to This Policy</h5>
        <p>
          We may update this Privacy Policy from time to time. Changes will be
          posted on this page with a revised effective date.
        </p>

        <h5 className="fw-bold mt-5">8. Contact Us</h5>
        <p>
          If you have any questions about this Privacy Policy, please email us
          at:
          <a href="mailto:support@banksstatements.com"> support@banksstatements.com</a>
        </p>
      </Container>
      </div>
      <Footer />
    </>
  );
}

export default Privacy;
